import { Row, Col, Card, Empty, Typography } from "antd"
import { DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { inwardPartner } from "../../store/gloabalState"
import { useRecoilValue } from "recoil"

const UboCard = ({
    mode,
    editUbo,
    selectionValue,
    shareHoldersFetch,
    showDeleteConfirm,
}) => {

    const partnerState = useRecoilValue(inwardPartner)

    return (
        <div style={{ padding: "8px" }}>
            <Row>
                {shareHoldersFetch?.length ? (
                    shareHoldersFetch.map((elem, i) => {
                        if (elem.status === "DISABLED") {
                            return false
                        }
                        let dob_
                        if (elem?.dob !== null && elem?.dob !== "null") {
                            dob_ = elem?.dob
                        }
                        return (
                            <Col span={12} key={i} style={{ overflowX: "hidden" }}>
                                <Card
                                    className="directors_card"
                                    title={<b>{elem?.name}</b>}
                                    style={{
                                        width: 400,
                                        borderRadius: "5px",
                                        border: "0.9px solid rgba(0,0,0,0.3)",
                                        overflow: "hidden"
                                    }}
                                    bordered
                                    hoverable
                                    disabled={mode === 'view' ? true : false}
                                    actions={[
                                        <DeleteOutlined
                                            key={"delete"}
                                            style={
                                                mode === "view"
                                                    ? { color: "red", opacity: ".3" }
                                                    : { color: "red" }
                                            }
                                            onClick={() =>
                                                (mode !== "view") && showDeleteConfirm(elem, "ubo")
                                            }
                                            disabled={(mode === "view")}
                                        />,
                                        <EditOutlined
                                            key="edit"
                                            onClick={() => {
                                                mode !== 'view' &&
                                                    editUbo(elem)
                                            }}
                                        />
                                    ]}
                                >
                                    {selectionValue === "outward" ||
                                        selectionValue === "both" ? (
                                        <>
                                            <p>
                                                Designation: <span>{elem.designation}</span>
                                            </p>
                                            <p>
                                                DOB: <span>{dob_ && dob_}</span>
                                            </p>
                                        </>
                                    ) : (
                                        ""
                                    )}
                                    {
                                        partnerState?.includes("payglocal") ?
                                            <p>
                                                Email: <span>{elem.emailId}</span>
                                            </p> : <p>
                                                Nationality: <span>{elem.nationality}</span>
                                            </p>
                                    }
                                    {selectionValue === "outward" ||
                                        selectionValue === "both" ? (
                                        <>
                                            {" "}
                                            <p>
                                                Gender: <span>{elem.gender}</span>
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </Card>
                            </Col>
                        )
                    })
                ) : (
                    <Empty
                        style={{ width: "100%" }}
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={
                            <Typography.Title
                                level={5}
                                style={{
                                    padding: ".5rem",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    color: "grey"
                                }}
                            >
                                No UBO's added yet!
                            </Typography.Title>
                        }
                    />
                )}
            </Row>
        </div>
    )

}

export default UboCard;